import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark" | "system";

interface UiStore {
  themeMode: ThemeMode;
  setThemeMode: (mode: ThemeMode) => void;

  siderCollapsed: boolean;
  toggleSider: () => void;
  setSiderCollapsed: (collapsed: boolean) => void;
}

export const useUiStore = create<UiStore>()(
  persist(
    (set) => ({
      themeMode: "system",
      setThemeMode: (mode) => set({ themeMode: mode }),

      siderCollapsed: true,
      toggleSider: () => set((state) => ({ siderCollapsed: !state.siderCollapsed })),
      setSiderCollapsed: (collapsed) => set({ siderCollapsed: collapsed }),
    }),
    {
      name: "acweb_ui",
    },
  ),
);
